import { useCachedApiCall } from '@hooks/apiCall';
import { employeeWagesCache } from './employeeFinanceStore';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 */

/** Cache-backed employee wages of a department. */
export const useEmployeeWagesEntry = (departmentId?: string) =>
    useCachedApiCall(employeeWagesCache, [departmentId]);
